import { atom } from 'jotai';

export const comparedTextAtom = atom('');